import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { AppContext } from './AppContext';
import { api } from '../services/api';

export const OrderConfirmationPaymentContext = createContext({
  paymentProviders: null,
  loading: true,
  refetchPaymentProviders: async () => {},
});

export const OrderConfirmationPaymentProvider = ({ children }) => {
  const { storeId, updatePaymentProviders} = useContext(AppContext);
  const [paymentProviders, setPaymentProviders] = useState(null);
  const [loading, setLoading] = useState(true);

  const refetchPaymentProviders = useCallback(async () => {
    if (storeId == null) {
      setPaymentProviders(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const data = await api.getPaymentProviders(storeId);
      setPaymentProviders(data);
      updatePaymentProviders(data);
    } catch (error) {
      console.error('Error getting payment providers:', error);
      setPaymentProviders(null);
    } finally {
      setLoading(false);
    }
  }, [storeId, updatePaymentProviders]);

  useEffect(() => {
    refetchPaymentProviders();
  }, [refetchPaymentProviders]);

  const value = {
    paymentProviders,
    loading,
    refetchPaymentProviders,
  };

  return (
    <OrderConfirmationPaymentContext.Provider value={value}>
      {children}
    </OrderConfirmationPaymentContext.Provider>
  );
};
